// Light/Dark mode toggle for the site with icon/text swap
(function(){
    var root = document.documentElement;
    var themeToggle = document.getElementById('themeToggle');
    var iconSpan = themeToggle ? themeToggle.querySelector('.shs-mode-toggle__icon') : null;
    var textSpan = themeToggle ? themeToggle.querySelector('.shs-mode-toggle__text') : null;

    function applyTheme(theme){
        root.dataset.theme = theme;
        if(themeToggle && iconSpan && textSpan){
            themeToggle.setAttribute('aria-pressed', String(theme === 'dark'));
            if(theme === 'dark') {
                iconSpan.innerHTML = '&#x1F319;'; // Moon
                textSpan.textContent = 'light mode';
            } else {
                iconSpan.innerHTML = '&#x2600;'; // Sun
                textSpan.textContent = 'dark mode';
            }
        }
    }

    function initTheme(){
        var stored = localStorage.getItem('theme');
        var theme = stored || 'dark';
        applyTheme(theme);
    }

    function toggleTheme(){
        var current = root.dataset.theme === 'dark' ? 'dark' : 'light';
        var next = current === 'dark' ? 'light' : 'dark';
        applyTheme(next);
        localStorage.setItem('theme', next);
    }

    if(themeToggle){
        themeToggle.addEventListener('click', toggleTheme);
        themeToggle.addEventListener('keydown', function(e){
            if(e.key === 'Enter'){toggleTheme();}
        });
    }

    initTheme();
})();
